import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { UpsertSubmissionTemplateBody } from 'src/openapi/models';
import { getFormattedErr } from 'src/helpers';
import apiClient from 'src/helpers/apiClient';

export const fetchSubmissionTemplates = createAsyncThunk(
  'submissionTemplate/fetchAll',
  async (
    { includeArchived }: { includeArchived?: boolean },
    { rejectWithValue, signal },
  ) => {
    try {
      const response = await (
        await apiClient.getCompetitionApi()
      ).competitionApiGetSubmissionTemplates(
        { includeArchived },
        {
          signal,
        },
      );
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertSubmissionTemplate = createAsyncThunk(
  'submissionTemplate/upsert',
  async (
    { payload }: { payload: UpsertSubmissionTemplateBody },
    { rejectWithValue },
  ) => {
    try {
      const api = await apiClient.getCompetitionApi();
      const response = payload.id
        ? await api.competitionApiUpdateSubmissionTemplate({
            templateId: payload.id,
            upsertSubmissionTemplateBody: payload,
          })
        : await api.competitionApiCreateSubmissionTemplate({
            upsertSubmissionTemplateBody: payload,
          });
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteSubmissionTemplate = createAsyncThunk(
  'submissionTemplate/delete',
  async ({ templateId }: { templateId: string }, { rejectWithValue }) => {
    try {
      await (
        await apiClient.getCompetitionApi()
      ).competitionApiDeleteSubmissionTemplate({ templateId });
      return { templateId };
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    }
  },
);
